import axios from "axios";
import AuthService from "./AuthService";

let interceptorsRegistered = false;

const loginHashRoute = "#/login";
const apiBase = process.env.REACT_APP_API_BASE || "";

const isAuthenticationRequest = (url = "") =>
  String(url).toLowerCase().includes("authenticate");

const isApiRequest = (url = "") => String(url).startsWith(apiBase);

const redirectToLogin = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (window.location.hash !== loginHashRoute) {
    window.location.hash = loginHashRoute;
  }
};

const registerAxiosInterceptors = () => {
  if (interceptorsRegistered) {
    return;
  }

  axios.interceptors.request.use(
    async (config) => {
      if (config.skipAuthorization || !isApiRequest(config.url)) {
        return config;
      }

      const existingAuthorizationHeader =
        config.headers?.Authorization || config.headers?.authorization;
      if (existingAuthorizationHeader) {
        return config;
      }

      const accessToken = await AuthService.getAccessToken();
      if (!accessToken) {
        return config;
      }

      const headers = config.headers || {};
      headers.Authorization = `Bearer ${accessToken}`;
      config.headers = headers;

      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const statusCode = error?.response?.status;
      const requestUrl = error?.config?.url;
      const skipAuthRedirect = error?.config?.skipAuthRedirect;

      if (statusCode === 401 && !skipAuthRedirect && !isAuthenticationRequest(requestUrl)) {
        AuthService.logoutLocal();
        redirectToLogin();

        return new Promise(() => {});
      }

      return Promise.reject(error);
    }
  );

  interceptorsRegistered = true;
};

export default registerAxiosInterceptors;
